import LiveBanner from './live-banner'

import LiveBannerQuery from './live-banner.query'

export { LiveBannerQuery }

export default LiveBanner
